import { initialState } from "./state"

export default {
  updateUuid: (state, payload) => (state.uuid = payload),
  updateIsEditing: (state, payload) => (state.isEditing = payload),
  updateName: (state, payload) => (state.name = payload),
  updateCod: (state, payload) => (state.cod = payload),
  updateActive: (state, payload) => (state.active = payload),
  updateProviderId: (state, payload) => (state.providerId = payload),
  updateProvider: (state, payload) => (state.provider = payload),
  updateLayout: (state, payload) => (state.layout = payload),
  resetChain: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
